/**
 * Config arrays for signal rows rendered in the Student Status report.
 * Keeping these out of JSX makes the rendering components thin and testable.
 */

/** "What students have done" signal rows (period-based counts). */
export const DONE_SIGNALS = [
	{ key: 'withTasksCompleted', label: 'Assigned work', icon: 'assignment', tone: 'purple' },
	{ key: 'withExplorationSaved', label: 'Students who saved a college', icon: 'bookmark_added', tone: 'blue', hint: 'Students who saved at least one college to their wishlist in this period.' },
	// Career profile recorded — hidden until product defines a reliable period date.
	// { key: 'withCareerProfile', label: 'Career profile recorded', icon: 'person', tone: 'green' },
	{ key: 'withAssessment', label: 'Assessment completed', icon: 'psychology', tone: 'orange' },
]

/** Application prep stat rows (icons + labels). */
export const APP_PREP_STATS = [
	{ key: 'essays', label: 'Essays approved', valueKey: 'essaysApproved', totalKey: 'essaysAssigned', icon: 'edit_note' },
	{ key: 'lors', label: 'LoRs completed', valueKey: 'lorsCompleted', totalKey: 'lorsNeeded', icon: 'assignment' },
	{ key: 'docs', label: 'Documents completed', valueKey: 'docsCompleted', totalKey: 'docsTotal', icon: 'folder_open' },
]

/** "Student Coverage" signal rows (snapshot counts). */
export const COVERAGE_SIGNALS = [
	{ key: 'withSessionInPeriod', label: 'Students with ≥1 session', icon: 'calendar_today', tone: 'green' },
	{ key: 'withApplication', label: 'Students with ≥1 application', icon: 'assignment', tone: 'orange' },
	{ key: 'withAssignment', label: 'Students with ≥1 assignment', icon: 'task', tone: 'purple' },
]
